import * as React from 'react'

interface SLAIconProps {
  color?: string
  gradient?: boolean
  size?: number
  alt?: string
}

const SLAIcon: React.FC<SLAIconProps> = ({ color = '#888', gradient, size, alt = 'SLA Icon' }) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='m20.743 17.6-.64-2.657h-3.28l-.656 2.656H14.71l2.848-11.328h1.904L22.247 17.6zm-2.224-9.985h-.064l-1.44 6.192h2.896zM8.863 17.6V6.27h1.44v9.985h3.2v1.343zM6.936 14.592q0 .768-.24 1.392-.24.608-.656 1.024a2.7 2.7 0 0 1-.96.64q-.56.224-1.2.224a4 4 0 0 1-1.648-.352A3.4 3.4 0 0 1 1 16.56l.848-1.04q.368.48.912.752.56.272 1.12.272.72 0 1.184-.48.465-.48.464-1.392 0-.432-.144-.752a1.9 1.9 0 0 0-.4-.592 3 3 0 0 0-.592-.48 5.6 5.6 0 0 0-.704-.416 8 8 0 0 1-.88-.496 4.2 4.2 0 0 1-.72-.656 2.9 2.9 0 0 1-.512-.864 3.7 3.7 0 0 1-.176-1.2q0-.816.256-1.424a3 3 0 0 1 .672-1.008 2.8 2.8 0 0 1 .976-.592Q3.848 6 4.408 6q.816 0 1.456.272.656.271 1.088.816l-.864 1.024q-.608-.8-1.632-.8-.304 0-.608.112a1.35 1.35 0 0 0-.528.336q-.24.224-.384.576a2.2 2.2 0 0 0-.144.848q0 .432.128.752.144.305.368.56.24.24.544.448.304.191.656.368.448.225.88.512.433.272.784.656t.56.912q.224.512.224 1.2'
      ></path>
    </svg>
  )
}

export default SLAIcon
